import { Avatar, Box, Paper, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import type { FC, ReactNode } from "react";

// Styled components for the Teams message appearance
const MessageContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  marginBottom: theme.spacing(2),
  alignItems: "flex-start",
  maxWidth: "80%",
}));

const SenderInfo = styled(Box)({
  display: "flex",
  alignItems: "center",
  marginBottom: "4px",
});

const MessageBubble = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  backgroundColor: "#F0F0F0", // Light gray background similar to Teams
  borderRadius: "8px",
  boxShadow: "none",
  width: "100%",
}));

const SenderName = styled(Typography)({
  fontWeight: 500,
  fontSize: "14px",
  marginLeft: "8px",
  color: "#252424",
});

const TimeStamp = styled(Typography)({
  fontSize: "12px",
  color: "#616161",
  marginLeft: "8px",
});

interface TeamsMessageProps {
  children: ReactNode;
  sender?: {
    name: string;
    avatarSrc?: string;
    initials?: string;
  };
  timestamp?: string;
  position?: "left" | "right";
  width?: string | number;
  className?: string;
}

export const TeamsMessageSender: FC<TeamsMessageProps> = ({
  children,
  sender = { name: "ChangeEngine", initials: "C" },
  timestamp = new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
}) => {
  return (
    <MessageContainer>
      <Avatar
        src={sender.avatarSrc}
        sx={{
          bgcolor: "#6264A7",
          width: 32,
          height: 32,
          mx: 1,
        }}
      >
        {!sender.avatarSrc && sender.initials}
      </Avatar>

      <Box sx={{ maxWidth: "calc(100% - 40px)" }}>
        <SenderInfo>
          <SenderName>{sender.name}</SenderName>
          <TimeStamp>{timestamp}</TimeStamp>
        </SenderInfo>

        <MessageBubble
          sx={{
            borderRadius: 1,
            backgroundColor: "#F0F0F0",
          }}
        >
          {children}
        </MessageBubble>
      </Box>
    </MessageContainer>
  );
};
